import { SeoMainContainer } from '@/modules/Seo';

const Seo = (): JSX.Element => <SeoMainContainer />;

export default Seo;
